'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Provider } from '@navikt/ds-react';
import { en, nb, nn } from '@navikt/ds-react/locales';
import { DecoratorClient } from './DecoratorClient';
import Store from './Store';
import { getTexts } from '@/texts/getTexts';
import { LanguageProvider } from '@/texts/LanguageProvider';
const locales = {
  nb,
  nn,
  en
} as const;
export default function AppClient(t0) {
  const $ = _c(15);
  const {
    children,
    lang,
    kontekst,
    initialData
  } = t0;
  let t1;
  if ($[0] !== lang) {
    t1 = getTexts(lang);
    $[0] = lang;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const tekst = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <DecoratorClient />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = locales[lang];
  let t4;
  if ($[3] !== children) {
    t4 = <div className="app-content">{children}</div>;
    $[3] = children;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4 || $[6] !== tekst) {
    t5 = <LanguageProvider texts={tekst}>{t4}</LanguageProvider>;
    $[5] = t4;
    $[6] = tekst;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t5) {
    t6 = <Provider locale={t3}>{t5}</Provider>;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== initialData || $[12] !== kontekst || $[13] !== t6) {
    t7 = <Store kontekst={kontekst} initialData={initialData}>{t2}{t6}</Store>;
    $[11] = initialData;
    $[12] = kontekst;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}